import Message from '../components/Message';

export default (function (w, d) {
    'use strict';

    function NegotiationController() {
        this.initNegotiation();
    }

    NegotiationController.prototype.initNegotiation = function () {
        (function ($) {
            $(function () {
                $('.offer-status-button').click(function (e) {
                    e.preventDefault();

                    var _ = $(this);
                    var args = {
                        id: _.data('id'),
                        action: _.data('action'),
                        _token: $('meta[name="csrf-token"]').attr('content')
                    };

                    if (_.hasClass('offer-answer-button')) {
                        args.price = $('.offer-input-' + args.id).val();
                    }

                    $.post(_.data('url'), args, function (response) {
                        if (response.status === 'success') {
                            _.parents('.offer-buttons').html('');
                            $('.offer-status-item-' + response.offer_id).html(response.offer_status_text);
                            var group_id = response.group_id;

                            if (response.offer_status == 2) {
                                $('.offer-item-accepted.offer-status-group-' + group_id)
                                    .not('.offer-status-item-' + response.offer_id)
                                    .html(response.decline_status_text);
                                location.reload();
                            } else {
                            }
                        }
                        new Message(response.message, response.status);
                    });
                });
            })
        }(jQuery))
    };

    return NegotiationController;
}(window, document));

